import SimpleBar from "simplebar";

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".wp-block-create-block-cityprop-ajax-objects-filters").forEach(block => {	
		var showResults = block.querySelector(".show-results");
		var closeFilters = block.querySelector(".close-filters");
		var formWrapper = block.querySelector(".cp-ajax-objects-filters-form-wrapper");

		setFiltersFormWrapperHeight();

		new SimpleBar(formWrapper);

		block.classList.add("show");

		const urlParams = new URLSearchParams(window.location.search);

		const form = document.querySelector("#cp-ajax-objects-filters");

		if (!form) {
			return;
		}

		const tsInstances = [];
		const selectValues = {};

		const defaultValues = {
			"radio_price_type": "price"
		};

		const clearBtns = block.querySelectorAll(".clear-filters, .mobile-clear-filters");

		if (clearBtns) {
			clearBtns.forEach(function (clearBtn) {
				clearBtn.addEventListener("click", () => {
					clearFormData();
				});
			});
		}

		let selects = block.querySelectorAll("select");

		bindEventHandlers();

		selects.forEach(element => {
			let initialValues = [];
			Array.from(element.options).forEach(option => {
				initialValues.push({ "value": option.text, "text": option.text, "id": option.getAttribute("data-id"), "parent": option.getAttribute("data-parent") });
			});
			selectValues[element.getAttribute("id")] = initialValues;

			var settings = {
				placeholder: element.getAttribute('data-placeholder'),
				onChange: value => {
					updateDependantElement(element, value);
					createFormUpdateEvent();
				}, render: {
					option: function (data, escape) {
						var attributes = getSelectAttributes(data);
						return '<div' + attributes + '>' + escape(data.text) + '</div>';
					},
					item: function (data, escape) {
						var attributes = getSelectAttributes(data);
						return '<div' + attributes + '>' + escape(data.text) + '</div>';
					}
				},
				onInitialize: () => {
					getFormDataFromUrlForSelect(urlParams, element);
					if (element.getAttribute("data-changes")) {
						return;
					}
					updateDependingElement(element);
				},
				plugins: {
					dropdown_input: {}
				}
			};
			//if (element.getAttribute('data-multiple')) {
				settings.plugins.remove_button = {
					title: 'Eemalda',
				}
			//}
			if (element.getAttribute('data-checkbox')) {
				settings.plugins.checkbox_options = {
					checkedClassNames: ['ts-checked', 'form-check-input'],
					uncheckedClassNames: ['ts-unchecked', 'form-check-input'],
				}
			}

			tsInstances.push(element.getAttribute("id"));

			var ts = new TomSelect(element, settings);

			if (element.getAttribute("id") == 'features_select') {
				var spacer = block.querySelector(".form-spacer");
				ts.on("dropdown_open", function (e) {
					spacer.style.height = e.offsetHeight + "px";
				});
				ts.on("dropdown_close", function (e) {
					spacer.style.height = 0;
				});
			}
		});

		function getSelectAttributes(data) {
			var attributes = {};
			if (data.id) {
				attributes["data-id"] = data.id;
			}
			if (data.parent) {
				attributes["data-parent"] = data.parent;
			}

			return " " + Object.keys(attributes).map(value => value + "=" + attributes[value]).join(" ") + " ";
		}

		function updateDependingElement(element) {
			var depends = element.getAttribute("data-depends");
			var changes = element.getAttribute("data-changes");
			if (depends) {
				var parentEl = block.querySelector("#" + depends);
				if (parentEl) {
					updateDependingElement(parentEl);
				}
			} else if (changes) {
				updateDependantElement(element, element.tomselect.getValue());
			}
		}

		function updateDependantElement(element, value) {
			var dependant = element.getAttribute('data-changes');
			var dependantElem = block.querySelector("#" + dependant);
			var ts = element.tomselect;

			if (!dependant || !dependantElem || !ts) {
				return;
			}

			var id = dependantElem.getAttribute("id");
			var dependantTs = dependantElem.tomselect;

			if (!value) {
				ts.setValue("", true);
				dependantTs.disable();
				dependantTs.setValue("");
			} else {
				dependantTs.enable();
				var currentValue = dependantTs.getValue();
				var newValue = "";
				var parentItem = ts.getItem(value);
				var values = selectValues[id];

				if (dependantTs && values) {
					values = values.filter(item => item.parent == parentItem.getAttribute("data-id"));
					dependantTs.clearOptions();
					dependantTs.addOptions(values);
					dependantTs.refreshOptions(false);
				}

				if (values.filter(v => v.value === currentValue).length) {
					newValue = currentValue;
				}

				dependantTs.setValue(newValue);
			}
			updateDependantElement(dependantElem, dependantElem.tomselect.getValue());
		}

		block.querySelectorAll(".form-control:not(.search)").forEach(element => {
			element.addEventListener("input", debounce(function (e) {
				createFormUpdateEvent();
			}, 300));
		});

		block.querySelectorAll(".cp-ajax-objects-filter.search").forEach(element => {
			var btn = element.querySelector(".input-group-btn");
			btn.addEventListener("click", function () {
				createFormUpdateEvent();
			});
		});

		block.querySelectorAll(".cp-ajax-objects-filter.buttons").forEach(element => {
			element.buttonValues = [];

			var buttons = element.querySelectorAll(".btn");
			var input = element.querySelector(".buttons-container");

			buttons.forEach(btn => {
				var btnVal = btn.getAttribute('data-value');
				btn.addEventListener("click", () => {
					if (element.buttonValues.includes(btnVal)) {
						element.buttonValues.splice(element.buttonValues.indexOf(btnVal), 1);
						btn.classList.remove("active");
					} else {
						element.buttonValues.push(btnVal);
						btn.classList.add("active");
					}
					createFormUpdateEvent();
				})
			})

			getFormDataFromUrlForButtons(urlParams, element, buttons, input);
		});

		block.querySelectorAll(".cp-ajax-objects-filter.price").forEach(element => {
			var priceType = element.querySelectorAll(".price-type");
			var priceTypeChecked = element.querySelector(".price-type:checked");

			if (!priceTypeChecked && priceType.length) {
				priceTypeChecked = priceType[0];
				if (priceTypeChecked) {
					priceTypeChecked.checked = true;
				}
			}
			priceType.forEach(elem => {
				elem.addEventListener("change", () => {
					createFormUpdateEvent();
				})
			})
		});

		function getFormDataFromUrl(params) {
			block.querySelectorAll("input, textarea").forEach(input => {
				var inputType = input.getAttribute("type");

				if (params.has(input.name) && inputType != "radio") {
					input.value = params.get(input.name);
				} else if (params.has(input.name) && inputType == 'radio') {
					var value = params.get(input.name);
					if (value == input.value) {
						input.checked = true;
					}
				}
			});

			var filtersCount = 0;
			if (filtersCount > 0) {
				if (clearBtns) {
					clearBtns.forEach(clearBtn => clearBtn.classList.remove("no-filters"));
				}
			}
		}

		function getFormDataFromUrlForSelect(params, element) {
			const values = [];
			params.forEach((key, param) => {
				if (param === element.name) {
					values.push(key);
				}
			});
			element.tomselect.setValue(values, true);
		}

		function bindEventHandlers() {
			var send = sendInitialFormData();
			var sendCount = 0;

			if (!send) {
				var sendInterval = setInterval(function () {
					sendCount++;
					send = sendInitialFormData();
					if (send || sendCount > 10) {
						clearInterval(sendInterval);
					}
				}, 100);
			}

			document.addEventListener("cp-moving-header", (e) => {
				if (!e.detail?.fixedToTop) {
					form.classList.remove("fixed-to-top");
				} else if (!form.classList.contains("fixed-to-top")) {
					form.classList.add("fixed-to-top");
				}
			})

			window.addEventListener("resize", function() {
				setFiltersFormWrapperHeight(showResults, closeFilters, formWrapper);
			});

			closeFilters.addEventListener("click", function () {
				hideFiltersContainer();
			});

			showResults.addEventListener("click", function() {
				hideFiltersContainer();
			});
		}

		function hideFiltersContainer() {
			var filtersContainer = document.querySelector(".cp-filters-container");
			if (filtersContainer) {
				filtersContainer.classList.remove("open");
			}
		}

		function sendInitialFormData() {
			var objectBlock = document.querySelector(".wp-block-create-block-cityprop-ajax-objects");
			if (objectBlock.classList.contains("loaded")) {
				createFormUpdateEvent(true);
				return true;
			}
			return false;
		}

		function getFormDataFromUrlForButtons(params, element, buttons, input) {
			const values = [];
			params.forEach((key, param) => {
				if (param === input.getAttribute("data-name")) {
					values.push(key);
				}
			});
			element.buttonValues = values;
			buttons.forEach(btn => {
				var btnVal = btn.getAttribute("data-value");
				if (element.buttonValues.includes(btnVal)) {
					btn.classList.add("active");
				}
			})
		}

		function clearFormData() {
			block.querySelectorAll(".form-control").forEach(element => {
				element.value = "";
			});

			block.querySelectorAll("select").forEach(element => {
				if (element.tomselect) {
					element.tomselect.setValue("", true);
				}
			});

			block.querySelectorAll(".buttons").forEach(elem => {
				var buttons = elem.querySelectorAll(".btn");
				buttons.forEach(btn => {
					btn.classList.remove("active");
				})

				elem.buttonValues = [];
			})

			if (clearBtns) {
				clearBtns.forEach(clearBtn => clearBtn.classList.add("no-filters"));
			}
			createFormUpdateEvent();
		}

		function createFormUpdateEvent(dontFetch) {
			const formDataObj = new FormData(form);
			const formData = new FormData();

			let extraParams = "";
			const existingParams = new URLSearchParams(window.location.search);
			if (existingParams.has("page_id")) {
				extraParams = "page_id=" + existingParams.get("page_id");
			}

			form.querySelectorAll(".buttons").forEach(elem => {
				var values = elem.buttonValues;
				var input = elem.querySelector('.buttons-container');
				var name = input.getAttribute("data-name");
				if (values) {
					values.forEach(value => {
						if (formData.has(name)) {
							formData.append(name, value);
						} else {
							formData.set(name, value)
						}
					})
				}
			})

			var filtersCount = 0;
			formDataObj.forEach((value, key) => {
				var defaultValue = defaultValues[key];

				if (value && value != defaultValue) {
					filtersCount++;
				}
				if (formData.has(key)) {
					formData.append(key, value);
				} else {
					formData.set(key, value);
				}
			})

			showOrHideClearBtn(filtersCount);
			createUpdateEvent({ formData: formData, extraParams: extraParams, dontFetch: dontFetch });
		}

		function showOrHideClearBtn(filtersCount) {
			if (filtersCount > 0) {
				clearBtns.forEach(clearBtn => clearBtn.classList.remove("no-filters"));
			} else {
				clearBtns.forEach(clearBtn => 
				clearBtn.classList.add("no-filters"));
			}
		}

		function createUpdateEvent(data) {
			const myEvent = new CustomEvent("cp-ajax-objects-filters", {
				detail: data
			});

			document.dispatchEvent(myEvent);
		}

		getFormDataFromUrl(urlParams);
	});
});

function debounce(func, delay) {
	let timer;
	return function () {
		clearTimeout(timer);
		timer = setTimeout(() => func.apply(this, arguments), delay);
	};
}

function setFormWrapperHeight(showResults, closeFilters, formWrapper) {
	var offsetHeight = Math.max(0, closeFilters.offsetHeight + showResults.offsetHeight);
	formWrapper.style.height = "calc(100vh - " + offsetHeight + "px)"; 
}